import {
  SalesOrderGenqlSelection,
  SalesOrderLineItemGenqlSelection,
} from '@rematter/frontend-lib-api-client';

export const purchaseOrderLineItemFragment = {
  __scalar: true,
  timestamps: {
    __scalar: true,
  },
  unitPrice: {
    __scalar: true,
  },
  totalPrice: {
    __scalar: true,
  },
  item: {
    __scalar: true,
    itemGroup: {
      name: true,
    },
  },
} satisfies SalesOrderLineItemGenqlSelection;

export const simplePurchaseOrderFragment = {
  id: true,
  documentNumber: true,
  counterpartyReferenceNumber: true,
  status: true,
  account: {
    id: true,
    name: true,
  },
  lineItems: {
    id: true,
    quantity: true,
    unit: true,
  },
  timestamps: {
    __scalar: true,
  },
  totalPrice: {
    __scalar: true,
  },
  shippedLoadsCount: true,
  fulfilledPercentage: true,
} satisfies SalesOrderGenqlSelection;

export const fullPurchaseOrderFragment = {
  ...simplePurchaseOrderFragment,
  startDate: true,
  endDate: true,
  customerInternalNotes: true,
  customerExternalNotes: true,
  recyclerExternalNotes: true,
  paymentCurrency: true,
  paymentTerm: true,
  freightTerm: true,
  lineItems: purchaseOrderLineItemFragment,
  accountRepresentative: {
    __scalar: true,
  },
  account: {
    __scalar: true,
    addresses: {
      address: {
        __scalar: true,
      },
    },
    contacts: {
      __scalar: true,
    },
  },
  contact: {
    __scalar: true,
  },
  customerFiles: {
    __scalar: true,
    metadata: true,
  },
  recyclerFiles: {
    __scalar: true,
    metadata: true,
  },
} satisfies SalesOrderGenqlSelection;
